"use client";

import { useTranslation } from "react-i18next";
import Gallery from "./Gallery";
import Divider from "./Divider";

type GallerySectionProps = {
  images: Array<{ url: string; alt?: string; isVertical?: boolean }>;
  roomTitle: string;
};

export default function GallerySection({
  images,
  roomTitle,
}: GallerySectionProps) {
  const { t } = useTranslation();

  // Ensure all images have alt text
  const imagesWithAlt: Array<{ url: string; alt: string; isVertical?: boolean }> = images.map((img) => ({
    url: img.url,
    alt: img.alt || `${roomTitle} ${t("photo")}`,
    isVertical: img.isVertical,
  }));

  return (
    <div className="overflow-x-hidden lg:min-w-0 mt-12 lg:mt-0">
      <h2 className="text-3xl md:text-4xl font-normal text-ui-card leading-tight" suppressHydrationWarning>
        {t("Gallery")}
      </h2>

      <Divider 
        mt="6" 
        width="100%" 
        className="mx-0! lg:w-181.5!" 
      />

      <Gallery images={imagesWithAlt} roomTitle={roomTitle} />
    </div>
  );
}

